"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectors = exports.entityReducer = exports.entityAdapter = exports.deleteOne = exports.addAdditionalDataToOne = exports.getInspectionReportPdf = exports.requestInspectionReportPdf = exports.createOne = exports.getMany = exports.getOne = exports.name = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var map_keys_deep_lodash_1 = __importDefault(require("map-keys-deep-lodash"));
var normalizr_1 = require("normalizr");
var config_1 = __importDefault(require("../config"));
var createEntityReducer_1 = __importDefault(require("../createEntityReducer"));
var entityTypes_1 = require("../tasks/entityTypes");
var entityTypes_2 = require("../wheelAnalysis/entityTypes");
var schema_1 = __importStar(require("./schema"));
var utils_1 = require("./utils");
exports.name = schema_1.key;
function mapCreatedInspection(id, createInspection, createdAt) {
    return {
        id: id,
        createdAt: createdAt,
        inspectionType: createInspection.inspectionType,
        accidentNature: createInspection.accidentNature,
        relatedInspectionId: createInspection.relatedInspectionId,
        additionalData: createInspection.additionalData,
        usageDuration: createInspection.usageDuration,
        tasks: [],
    };
}
function mapCreateInspectionKeysToSnakeCase(createInspection) {
    var _a, _b, _c, _d;
    var taskCallbacks = new Map();
    taskCallbacks.set('wheel_analysis', (_a = createInspection.tasks.wheelAnalysis) === null || _a === void 0 ? void 0 : _a.callbacks);
    taskCallbacks.set('repair_estimate', (_b = createInspection.tasks.repairEstimate) === null || _b === void 0 ? void 0 : _b.callbacks);
    taskCallbacks.set('images_ocr', (_c = createInspection.tasks.imagesOcr) === null || _c === void 0 ? void 0 : _c.callbacks);
    taskCallbacks.set('damage_detection', (_d = createInspection.tasks.damageDetection) === null || _d === void 0 ? void 0 : _d.callbacks);
    var result = (0, map_keys_deep_lodash_1.default)(createInspection, function (v, k) { return (0, lodash_1.snakeCase)(k); });
    taskCallbacks.forEach(function (callbacks, snakeCaseTask) {
        if (callbacks) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            result.tasks[snakeCaseTask].callbacks = callbacks;
        }
    });
    return result;
}
/**
 * Note(Ilyass): Since there is still a bug from BE, which is wheel_analysis property
 * is always null, as a workaround we are pulling wheel_analysis from images, and wheelName
 * from tasks.images.details.wheel_name
 */
function getWheelAnalysis(inspection) {
    var _a;
    // we try to get the WA from the root of the inspection, if we can't, we get it from images
    if (inspection.wheelAnalysis) {
        return inspection.wheelAnalysis;
    }
    var wheelAnalysisTask = inspection.tasks.find(function (task) { return task.name === entityTypes_1.TaskName.WHEEL_ANALYSIS; });
    var getTaskImageById = function (imageId) { return wheelAnalysisTask.images.find(function (img) { return img.imageId === imageId; }); };
    var getWheelName = function (image) {
        var _a, _b, _c;
        // we try to get the wheelname from tasks (will be present only if we pass
        // them while creating the task)
        var taskDetails = (_a = getTaskImageById(image.id)) === null || _a === void 0 ? void 0 : _a.details;
        if (taskDetails === null || taskDetails === void 0 ? void 0 : taskDetails.wheelName) {
            return taskDetails.wheelName;
        }
        // if always no wheelName we try to predict a wheelName from the viewpoint
        return (_c = entityTypes_2.WheelTypeByPrediction[(_b = image === null || image === void 0 ? void 0 : image.viewpoint) === null || _b === void 0 ? void 0 : _b.prediction]) !== null && _c !== void 0 ? _c : '';
    };
    return (_a = inspection.images) === null || _a === void 0 ? void 0 : _a.filter(function (img) { return img === null || img === void 0 ? void 0 : img.wheelAnalsis; }).map(function (img) { return (__assign(__assign({}, img.wheelAnalsis), { wheelName: getWheelName(img) || img.wheelAnalsis.wheelName, imageId: img.id })); });
}
/**
 * Get one inspection by ID.
 *
 * @param {string} id The uuid of the inspection to get.
 * @param {GetOneInspectionOptions} [options] The fetch options.
 */
function getOne(id, options) {
    return __awaiter(this, void 0, void 0, function () {
        var params, axiosResponse, inspection, wheelAnalysis, inspectionWithWheelAnalysis;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = (0, map_keys_deep_lodash_1.default)(options, function (v, k) { return (0, lodash_1.snakeCase)(k); });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'get', url: "/inspections/".concat(id), params: (0, lodash_1.omitBy)(params, lodash_1.isNil) }))];
                case 1:
                    axiosResponse = _b.sent();
                    inspection = (0, map_keys_deep_lodash_1.default)(axiosResponse.data, function (v, k) { return (0, lodash_1.camelCase)(k); });
                    wheelAnalysis = getWheelAnalysis(inspection);
                    inspectionWithWheelAnalysis = __assign(__assign({}, inspection), { wheelAnalysis: wheelAnalysis });
                    return [2 /*return*/, __assign((_a = { axiosResponse: axiosResponse }, _a[schema_1.idAttribute] = id, _a), (0, normalizr_1.normalize)(inspectionWithWheelAnalysis, schema_1.default))];
            }
        });
    });
}
exports.getOne = getOne;
/**
 * Get a page of inspection entities.
 *
 * @param {GetManyInspectionsOptions} [options] - The query options.
 */
function getMany(options) {
    return __awaiter(this, void 0, void 0, function () {
        var params, axiosResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, map_keys_deep_lodash_1.default)(options, function (v, k) { return (0, lodash_1.snakeCase)(k); });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'get', url: '/inspections', params: (0, lodash_1.omitBy)(params, lodash_1.isNil) }))];
                case 1:
                    axiosResponse = _a.sent();
                    return [2 /*return*/, __assign({ axiosResponse: axiosResponse }, (0, normalizr_1.normalize)((0, map_keys_deep_lodash_1.default)(axiosResponse.data.data, function (v, k) { return (0, lodash_1.camelCase)(k); }), [schema_1.default]))];
            }
        });
    });
}
exports.getMany = getMany;
/**
 * Create a new inspection.
 *
 * @param {CreateInspection} createInspection - The details of the inspection to create.
 */
function createOne(createInspection) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var environment, axiosResponse, id, createdEntity;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    environment = (0, utils_1.getCurrentEnvSpecs)();
                    createInspection.additionalData = __assign(__assign({}, ((_a = createInspection.additionalData) !== null && _a !== void 0 ? _a : {})), { environment: environment });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'post', url: '/inspections', data: mapCreateInspectionKeysToSnakeCase(createInspection) }))];
                case 1:
                    axiosResponse = _c.sent();
                    id = axiosResponse.data[schema_1.idAttribute];
                    createdEntity = mapCreatedInspection(id, createInspection, new Date().toISOString());
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(createdEntity, schema_1.default))];
            }
        });
    });
}
exports.createOne = createOne;
/**
 * Add additional information to an inspection.
 *
 * @param {string} id - The id of the inspection.
 * @param {RequestInspectionReportPdfParams} payload - The payload of the request.
 */
function requestInspectionReportPdf(id, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var data, axiosResponse, entity;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    data = (0, map_keys_deep_lodash_1.default)(payload, function (v, k) { return (0, lodash_1.snakeCase)(k); });
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'post', url: "/inspections/".concat(id, "/pdf"), data: data }))];
                case 1:
                    axiosResponse = _c.sent();
                    entity = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a);
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(entity, schema_1.default))];
            }
        });
    });
}
exports.requestInspectionReportPdf = requestInspectionReportPdf;
/**
 * Add additional information to an inspection.
 *
 * @param {string} id - The id of the inspection.
 */
function getInspectionReportPdf(id) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, entity;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'get', url: "/inspections/".concat(id, "/pdf") }))];
                case 1:
                    axiosResponse = _c.sent();
                    axiosResponse.data = (0, map_keys_deep_lodash_1.default)(axiosResponse.data, function (v, k) { return (0, lodash_1.camelCase)(k); });
                    entity = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a);
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(entity, schema_1.default))];
            }
        });
    });
}
exports.getInspectionReportPdf = getInspectionReportPdf;
/**
 * Add additional information to an inspection.
 *
 * @param {string} id - The id of the inspection.
 * @param {PdfInputData} data - The additional information to add to the inspection.
 */
function addAdditionalDataToOne(id, data) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, entity;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'patch', url: "/inspections/".concat(id, "/pdf_data"), data: (0, map_keys_deep_lodash_1.default)(data, function (v, k) { return (0, lodash_1.snakeCase)(k); }) }))];
                case 1:
                    axiosResponse = _c.sent();
                    entity = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a.additionalData = {
                            pdfData: data,
                        },
                        _a);
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(entity, schema_1.default))];
            }
        });
    });
}
exports.addAdditionalDataToOne = addAdditionalDataToOne;
/**
 * Delete an inspection.
 *
 * @param {string} id - The id of the inspection.
 */
function deleteOne(id) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'delete', url: "/inspections/".concat(id) }))];
                case 1:
                    axiosResponse = _c.sent();
                    result = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a);
                    return [2 /*return*/, __assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(result, schema_1.default))];
            }
        });
    });
}
exports.deleteOne = deleteOne;
function emptyInspection(id) {
    var _a;
    return _a = {},
        _a[schema_1.idAttribute] = id,
        _a.images = [],
        _a.damages = [],
        _a.parts = [],
        _a.wheelAnalysis = [],
        _a.tasks = [],
        _a.documents = [],
        _a.severityResults = [],
        _a;
}
exports.entityAdapter = (0, toolkit_1.createEntityAdapter)({});
exports.entityReducer = (0, createEntityReducer_1.default)(schema_1.key, exports.entityAdapter);
exports.selectors = exports.entityAdapter.getSelectors(function (state) { return state[schema_1.key]; });
exports.default = (0, toolkit_1.createSlice)({
    name: schema_1.key,
    initialState: exports.entityAdapter.getInitialState({ entities: {}, ids: [] }),
    reducers: exports.entityReducer,
    extraReducers: function (builder) {
        builder.addCase('tasks/gotOne', function (state, action) {
            var _a;
            var _b = action.payload, result = _b.result, inspectionId = _b.inspectionId;
            if (inspectionId && !(0, lodash_1.isEmpty)(result)) {
                var inspection = (_a = state.entities[inspectionId]) !== null && _a !== void 0 ? _a : emptyInspection(inspectionId);
                exports.entityAdapter.upsertOne(state, __assign(__assign({}, inspection), { tasks: Array.from(new Set(__spreadArray(__spreadArray([], inspection.tasks, true), [result], false))) }));
            }
        }).addCase('images/gotOne', function (state, action) {
            var _a;
            var _b = action.payload, result = _b.result, inspectionId = _b.inspectionId;
            if (inspectionId && !(0, lodash_1.isEmpty)(result)) {
                var inspection = (_a = state.entities[inspectionId]) !== null && _a !== void 0 ? _a : emptyInspection(inspectionId);
                exports.entityAdapter.upsertOne(state, __assign(__assign({}, inspection), { images: Array.from(new Set(__spreadArray(__spreadArray([], inspection.images, true), [result], false))) }));
            }
        });
    },
});
//# sourceMappingURL=index.js.map